import { useEffect, useState, useCallback } from "react";
import { useAppDispatch } from "app/hooks";
import { useAppSelector } from "app/hooks";
import useEmblaCarousel from "embla-carousel-react";

// Redux
import { getMedia } from "components/gallery/gallerySlice";

// Components
import { PrevButton, NextButton } from "./CarouselButtons";

// Helpers
import { getFileUrl } from "helpers/media";
import { useQuery } from "helpers/common";

// Styles
import styles from "./Gallery.module.scss";
//import VideoPlayer from "components/video-player/VideoPlayer";

const Gallery = () => {
  // Hooks
  const dispatch = useAppDispatch();
  const [carouselRef, carousel] = useEmblaCarousel();

  // Querystring values
  const query = useQuery();
  const queryId = query.get("id");
  const queryToken = query.get("token");

  // Redux state
  const { media } = useAppSelector((state) => state.media);

  // Local state
  const [id, setId] = useState<number | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const getLinkId = useCallback(() => {
    if (queryId) {
      setId(parseInt(queryId));
    }
  }, [queryId]);

  const getToken = useCallback(() => {
    if (queryToken) {
      setToken(queryToken);
    }
  }, [queryToken]);

  useEffect(() => {
    getLinkId();
    getToken();

    if (!id || !token) return;

    dispatch(getMedia({ id, token }));
  }, [id, token, getLinkId, getToken, dispatch]);

  const scrollPrev = useCallback(() => {
    carousel?.scrollPrev();
  }, [carousel]);

  const scrollNext = useCallback(() => {
    carousel?.scrollNext();
  }, [carousel]);

  const handleKeyPress = useCallback(
    (event: any) => {
      const { keyCode } = event;
      if (keyCode === 37) {
        scrollPrev();
      }
      if (keyCode === 39) {
        scrollNext();
      }
    },
    [scrollPrev, scrollNext]
  );

  const onSelect = useCallback(() => {
    if (!carousel) return;
    setPrevBtnEnabled(carousel.canScrollPrev());
    setNextBtnEnabled(carousel.canScrollNext());
  }, [carousel]);

  useEffect(() => {
    if (!carousel) return;
    onSelect();
    carousel.on("select", onSelect);
  }, [carousel, onSelect]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  if (!id || !token)
    return (
      <div className={styles.invalid}>
        <h1>Invalid Event</h1>
      </div>
    );

  if (!media.length) return null;

  return (
    <div className={styles.wrap}>
      <div className={styles.embla} ref={carouselRef}>
        <div className={styles.slides}>
          {media.map((file: any, i: number) => {
            return (
              <div key={i} className={styles.slide}>
                {file?.type === "video" ? (
                  // <VideoPlayer
                  //   src={getFileUrl(file)}
                  //   poster={getFileUrl(file, true)}
                  // />
                  <video
                    src={getFileUrl(file)}
                    className={styles.video}
                    loop
                    controls
                  />
                ) : (
                  <img src={getFileUrl(file)} alt={`Slide ${i}`} />
                )}
              </div>
            );
          })}
        </div>

        <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
        <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
      </div>
    </div>
  );
};

export default Gallery;
